import { Component } from '@angular/core';

@Component({
  selector: 'app-owner-survey-list',
  templateUrl: './owner-survey-list.component.html',
  styleUrls: ['./owner-survey-list.component.css']
})
export class OwnerSurveyListComponent {

}
